import { useSyncExternalStore } from 'react';

// true while the window is at least `px` wide (a phone folds the Sales search back into the tools)
export function useWide(px = 600) {
  const q = `(min-width: ${px}px)`;
  const get = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q).matches : true);
  const sub = (cb) => {
    if (typeof window === 'undefined' || !window.matchMedia) return () => {};
    const m = window.matchMedia(q); m.addEventListener('change', cb); return () => m.removeEventListener('change', cb);
  };
  return useSyncExternalStore(sub, get, () => true);
}
